import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ICorrectionTableAll } from "../interface/ICorrectionTableAll";

enum CorrectionTableServiceEnum {
  getAll = "/all",
  syncronize = "/syncronize"
}

export default class CorrectionTableService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/correction-table");
  }

  public getAll = async (): Promise<ICorrectionTableAll[]> => await this.GET(CorrectionTableServiceEnum.getAll);
  public syncronize = async (tableNameSync): Promise<ICorrectionTableAll[]> => await this.POST(CorrectionTableServiceEnum.syncronize, { tableName: tableNameSync });
}
